import { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../../contexts/AuthContext';
import ReceiptsPanel from './ReceiptsPanel';
import PaymentsPanel from './PaymentsPanel';
import './BankTransactions.css';

const API_URL = process.env.REACT_APP_API_URL;

export default function BankTransactions() {
  const { user } = useContext(AuthContext);

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState(null);

  const [hdfcFile, setHdfcFile] = useState(null);
  const [hdfcUploading, setHdfcUploading] = useState(false);
  const [hdfcMessage, setHdfcMessage] = useState(null);

  const [showReceipts, setShowReceipts] = useState(false);
  const [showPayments, setShowPayments] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setMessage(null);
  };

  const handleUpload = async () => {
    if (!file) { setMessage({ ok: false, text: 'Please select a file first.' }); return; }
    setUploading(true);
    setMessage(null);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await axios.post(`${API_URL}/bank-trasaction-upload/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${user?.token}` },
      });
      setMessage({ ok: true, text: res.data.message || 'File uploaded successfully.' });
      setFile(null);
      document.getElementById('bt-file-input').value = '';
    } catch (err) {
      setMessage({ ok: false, text: err.response?.data?.message || 'Error uploading file. Please try again.' });
    } finally {
      setUploading(false);
    }
  };

  const handleHdfcFileChange = (e) => {
    setHdfcFile(e.target.files[0] || null);
    setHdfcMessage(null);
  };

  const handleHdfcUpload = async () => {
    if (!hdfcFile) { setHdfcMessage({ ok: false, text: 'Please select a file first.' }); return; }
    setHdfcUploading(true);
    setHdfcMessage(null);
    const formData = new FormData();
    formData.append('file', hdfcFile);
    try {
      const res = await axios.post(`${API_URL}/bank-trasaction-upload/upload-hdfc`, formData, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${user?.token}` },
      });
      setHdfcMessage({ ok: true, text: res.data.message || 'HDFC file uploaded successfully.' });
      setHdfcFile(null);
      document.getElementById('bt-hdfc-file-input').value = '';
    } catch (err) {
      setHdfcMessage({ ok: false, text: err.response?.data?.message || 'Error uploading HDFC file. Please try again.' });
    } finally {
      setHdfcUploading(false);
    }
  };

  return (
    <div className="bt-page">
      <h1 className="bt-title">Bank Transactions</h1>

      {/* Upload */}
      <div className="bt-section">
        <h2 className="bt-section-title">Upload Bank Statement</h2>

        {/* Axis Bank */}
        <div className="bt-upload-row">
          <label className="bt-file-label" htmlFor="bt-file-input">
            Choose File
          </label>
          <input
            id="bt-file-input"
            type="file"
            accept=".xlsx,.xls"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
          {file && <span className="bt-file-name">{file.name}</span>}
          <button className="bt-btn-upload" onClick={handleUpload} disabled={uploading || !file}>
            {uploading ? 'Uploading...' : 'Upload Axis'}
          </button>
        </div>
        {message && (
          <div className={message.ok ? 'bt-msg-ok' : 'bt-msg-err'}>{message.text}</div>
        )}

        {/* HDFC Bank */}
        <div className="bt-upload-row bt-mt-8">
          <label className="bt-file-label" htmlFor="bt-hdfc-file-input">
            Choose File
          </label>
          <input
            id="bt-hdfc-file-input"
            type="file"
            accept=".xlsx,.xls"
            style={{ display: 'none' }}
            onChange={handleHdfcFileChange}
          />
          {hdfcFile && <span className="bt-file-name">{hdfcFile.name}</span>}
          <button className="bt-btn-upload" onClick={handleHdfcUpload} disabled={hdfcUploading || !hdfcFile}>
            {hdfcUploading ? 'Uploading...' : 'Upload HDFC'}
          </button>
        </div>
        {hdfcMessage && (
          <div className={hdfcMessage.ok ? 'bt-msg-ok' : 'bt-msg-err'}>{hdfcMessage.text}</div>
        )}
      </div>

      {/* Transactions navigation */}
      <div className="bt-section">
        <h2 className="bt-section-title">Transactions</h2>
        <div className="bt-btn-row">
          <button className="bt-btn-nav bt-btn-receipts" onClick={() => setShowReceipts(true)}>
            Receipts
          </button>
          <button className="bt-btn-nav bt-btn-payments" onClick={() => setShowPayments(true)}>
            Payments
          </button>
        </div>
      </div>

      {/* Receipts full-page modal */}
      {showReceipts && (
        <div className="bt-fm-overlay">
          <ReceiptsPanel onClose={() => setShowReceipts(false)} />
        </div>
      )}

      {/* Payments full-page modal */}
      {showPayments && (
        <div className="bt-fm-overlay">
          <PaymentsPanel onClose={() => setShowPayments(false)} />
        </div>
      )}
    </div>
  );
}
